import React, { useState } from "react";

import { FormInput_password } from "components";

import { func_validation } from "functions";

import "assets/scss/components/customs/form/customPasswordInput.scss";



export function CustomPasswordInput(props) {
    const { className, customInputClassName, label, password, isFormSubmissionAttempted, options } = props;

    let options_validated = func_validation.isObjectNotEmpty(options)? options:{};

	const [isPasswordVisible, setPasswordVisibility] = useState(false);

    function handleValueChange(value) {
        if (func_validation.isFunction(props.handleValueChange))
            props.handleValueChange(value);
    }

    function handleOnEnterPressed() {
        if (func_validation.isFunction(props.handleOnEnterPressed))
            props.handleOnEnterPressed();
    }
    
    return (
        <FormInput_password isInputSimplified
            className={className}
            customInputClassName={customInputClassName}

            inputLabel={label}

            inputPlaceholder={"Password"}
            inputName={'password'} inputStateName={'password'}
            customInputType={(isPasswordVisible)?'text':'password'} 
            inputValue={password} inputMaxLength={30} 

            propagateValueChange={(stateName, value) => { handleValueChange(value); }}
            handleInputBlurExtend={() => { setPasswordVisibility(false); }}

            handleInputEnterKeyPress={handleOnEnterPressed}
            isInputKeyPressHandlingRequired isFocusRemovedOnEnterKey

            isFormSubmissionAttempted={isFormSubmissionAttempted} 
            customErrorMsgDefault={"Password is required"} 

            inputCustomOptions={{ autoComplete: "off" }}

            isLabelOptional isInputOptional isInputBlurHandlingRequired
            isInputSideIconVisible

            {...options_validated}
        />
    )
}